<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="1000px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-dolly</v-icon>
            <span class="px-3">{{ $t('View Order information') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <table class="section-title-table only-for-print">
            <tr>
              <th class="section-title-content">{{ $t('Receive') }}</th>
            </tr>
          </table>

          <v-layout row wrap class="invoice-content">
            <v-flex xs12 sm12 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
              <v-layout row wrap>
                <table class="info-table" style="width: 100%">
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Sent Outlet') }}
                      </div>
                      <strong>{{ viewInfo.outlet_received || '-' }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Asset Type') }}
                      </div>
                      <strong>{{ $t(viewInfo.asset_type) }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Bill Number') }}
                      </div>
                      <strong>{{ viewInfo.bill_auto_number || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Bill Date') }}</div>
                      <strong v-if="viewInfo.bill_date">
                        {{ viewInfo.bill_date }}
                      </strong>
                      <strong v-else>-</strong>
                    </td>
                  </tr>
                </table>

                <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% Current ASSET %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% -->
                <table v-if="viewInfo.asset_type === 'Current'" class="printed-table" cellspacing="0">
                  <thead>
                    <tr class="only-for-print">
                      <td>
                        <div class="header-space">&nbsp;</div>
                      </td>
                    </tr>
                    <tr>
                      <th xs1 class="pa-2 view-table-header">#</th>
                      <th class="view-table-header" xs5 pa-2>
                        {{ $t('Product') }}
                      </th>
                      <th class="view-table-header" xs6 pa-2 v-if="hasCollection">
                        {{ $t('Collections') }}
                      </th>
                      <th class="view-table-header" xs3 pa-2>
                        {{ $t('Quantity') }}
                      </th>
                      <th class="view-table-header" xs3 v-if="settings.product_expiry === 'Active'">
                        {{ $t('Expiration Date') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in rowNumbers" :key="index">
                      <td class="view-table-row">
                        <p class="view-table-content">{{ index + 1 }}</p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.product_name[index] }}
                        </p>
                      </td>
                      <td class="view-table-row" v-if="hasCollection">
                        <p class="view-table-content">
                          {{ viewInfo.collection_name[index] }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.purchase_quantity[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row" v-if="settings.product_expiry === 'Active'">
                        <p class="view-table-content">
                          {{ viewInfo.expire_date[index] }}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="only-for-print">
                      <td>
                        <div class="footer-space">&nbsp;</div>
                      </td>
                    </tr>
                  </tfoot>
                </table>

                <!-- %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% Fixed ASSET %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% -->
                <table v-else-if="viewInfo.asset_type === 'Fixed'" class="printed-table" cellspacing="0">
                  <thead>
                    <tr class="only-for-print">
                      <td>
                        <div class="header-space">&nbsp;</div>
                      </td>
                    </tr>
                    <tr>
                      <th xs1 class="pa-2 view-table-header">#</th>
                      <th class="view-table-header" xs6 pa-2>
                        {{ $t('Product') }}
                      </th>
                      <th class="view-table-header" xs6 pa-2>
                        {{ $t('Lifespan') }}
                      </th>
                      <th class="view-table-header" xs6 pa-2>
                        {{ `${$t('Salvage Price')} (${systemCurrency})` }}
                      </th>
                      <th class="view-table-header" xs6 pa-2>
                        {{ `${$t('Purchase Price')} (${systemCurrency})` }}
                      </th>
                      <th class="view-table-header" xs3 pa-2>
                        {{ $t('Quantity') }}
                      </th>
                      <th class="view-table-header" xs2>
                        {{ `${$t('Total')} (${systemCurrency})` }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in rowNumbers" :key="index">
                      <td class="view-table-row">
                        <p class="view-table-content">{{ index + 1 }}</p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.product_name[index] }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.lifespan[index] }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.salvage_price[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.purchase_price[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.purchase_quantity[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.total[index] | currency }}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="only-for-print">
                      <td>
                        <div class="footer-space">&nbsp;</div>
                      </td>
                    </tr>
                  </tfoot>
                </table>

                <invoice-footer
                  :showSignatureSection="false"
                  :accountantName="''"
                  :payerRecipientName="''"
                  :payerOrRecipient="''"
                  class="only-for-print"
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">
            {{ $t('Close') }}
          </v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
// import * as helpers from '@/mixins/helperFunctions.js'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      viewInfo: {
        purchase_id: 0,
        outlet_received: '',
        bill_auto_number: '',
        bill_date: '',
        asset_type: '',
        product_name: [],
        collection_name: [],
        purchase_quantity: [],
        expire_date: [],
        lifespan: [],
        salvage_price: [],
        purchase_price: [],
        total: []
      },
      rowNumbers: 0
    }
  },

  computed: {
    ...mapGetters({
      receiveInfo: 'receives/getReceiveInfo',
      settings: 'configurations/getSystemSettings'
    }),
    hasCollection() {
      return this.settings.production_collections === 'Active'
    }
  },

  watch: {
    viewDialog: {
      immediate: false,
      handler() {
        if (this.viewDialog) {
          this.rowNumbers = this.receiveInfo.data_detail.length
          this.viewInfo.outlet_received = this.receiveInfo.data.outlet_received
          this.viewInfo.bill_auto_number = this.receiveInfo.data.bill_auto_number
          this.viewInfo.purchase_id = this.receiveInfo.data.purchase_id
          this.viewInfo.bill_date = this.receiveInfo.data.bill_date
          this.viewInfo.asset_type = this.receiveInfo.data.asset_type

          this.viewInfo.product_name = []
          this.viewInfo.collection_name = []
          this.viewInfo.purchase_quantity = []
          this.viewInfo.expire_date = []
          this.viewInfo.lifespan = []
          this.viewInfo.salvage_price = []
          this.viewInfo.purchase_price = []
          this.viewInfo.total = []

          this.receiveInfo.data_detail.forEach(c => {
            this.viewInfo.product_name.push(c.product_name)
            this.viewInfo.collection_name.push(c.collection_name)
            if (this.viewInfo.collection_name) {
              this.viewInfo.purchase_quantity.push(c.purchase_collection_quantity)
            } else {
              this.viewInfo.purchase_quantity.push(c.purchase_quantity)
            }
            this.viewInfo.lifespan.push(c.lifespan)
            this.viewInfo.salvage_price.push(c.salvage_price)
            this.viewInfo.purchase_price.push(c.purchase_price)
            this.viewInfo.total.push(c.purchase_quantity * c.purchase_price)
            this.viewInfo.expire_date.push(c.expire_date)
          })
        }
      }
    }
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    printMe() {
      let onlyForPrint = document.querySelectorAll('.only-for-print')
      let notPrintable = document.querySelectorAll('.not-printable')
      let invoiceContent = document.querySelector('.invoice-content')
      let theDialogContent = document.querySelector('.view-dialog-content')
      let infoTable = document.querySelector('.info-table')
      theDialogContent.classList.remove('grey')
      infoTable.classList.add('add-padding-for-info-table')
      invoiceContent.style.marginTop = '90px'
      notPrintable.forEach(element => {
        element.style.display = 'none'
      })
      onlyForPrint.forEach(element => {
        element.style.display = 'block'
      })
      document.querySelector('.printed-table').style.marginTop = '-120px'

      this.$htmlToPaper('printArea', () => {
        infoTable.classList.remove('add-padding-for-info-table')
        theDialogContent.classList.add('grey')
        invoiceContent.style.marginTop = '0px'
        onlyForPrint.forEach(element => {
          element.style.display = 'none'
        })
        notPrintable.forEach(element => {
          element.style.display = 'flex'
        })
        document.querySelector('.printed-table').style.marginTop = '0px'
      })
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
